import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui"; //全局引入element
import "element-ui/lib/theme-chalk/index.css"; //全局引入element css
import "@/styles/index.less"; // 全局 css
import VueClipBoard from "vue-clipboard2"; //复制
import vueMiniPlayer from "vue-mini-player"; //视频
import "vue-mini-player/lib/vue-mini-player.css"; //视频样式
import Vant from "vant";
import base from "./utils/base";
import './assets/css/font.css';
// 2. 引入组件样式
import "vant/lib/index.css";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(VueClipBoard);
Vue.use(vueMiniPlayer);
Vue.prototype.$base = base; //全局方法
Vue.prototype.$imgapi = "https://sxjingsai.oss-cn-hangzhou.aliyuncs.com"; //全局方法
Vue.prototype.$uploadapi = "https://jingsai.educhxun.com.cn/api/common/upload"; //全局方法
// Vue.prototype.$uploadapi = "https://jingsai.educhxun.com.cn/api/common/upload"; //全局方法
// Vue.prototype.$imgapi = "https://hengshuaitest.edochxun.com/"; //全局方法

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js